/* eslint-disable max-lines */
import { ThemeTypes } from "@/utils/theming";

export interface Child {
  name?: string;
  longName?: string;
  mode?: "core" | "root-cause";
  url: string;
  subtext?: string;
  subtextDesktop?: string;
  className?: string;
  isMens?: boolean;
  type?: "link" | "button";
  label?: string;
  image?: string;
  alt?: string;
  anchor?: string;
  text?: string;
  title?: string;
  subtitle?: string;
  tag?: string;
}

export interface Link {
  text: string;
  url: string;
}

export interface HeaderDataItem {
  name: string;
  link: Link;
  className?: string;
  childrenTitle?: string;
  rootCauseCategoriesTitle?: string;
  subCategoriesTitle?: string;
  isAlt?: boolean;
  isMobileOnly?: boolean;
  children?: Child[];
  subCategories?: Child[];
}

export type MenuType = "hgn" | "accordion" | "link" | "account";

export interface AccordionNavigationItem {
  type: MenuType;
  isMobileOnly?: boolean;
  open?: boolean;
  name?: string;
  title: string;
  url?: string;
  className?: string;
  tag?: string;
  children?: Child[];
}

const children: Child[] = [
  {
    name: "My Nutrafol",
    url: "/account/",
  },
  {
    name: "Orders",
    url: `/account/orders/`,
  },
  {
    name: "Subscriptions",
    url: `/account/subscriptions/`,
  },
  {
    name: "Profile",
    url: "/account/profile/",
  },
  {
    name: "Rewards",
    url: "/account/rewards/",
  },
  {
    name: "Get Support",
    url: "/our/brand/support/contact-us/",
  },
  {
    name: "Log Out",
    url: "",
  },
];

export const headerData: HeaderDataItem[] = [
  {
    name: "shop",
    childrenTitle: "Hair Growth Supplements",
    subCategoriesTitle: "Shop by Concern",
    isAlt: true,
    link: {
      text: "Shop",
      url: "#",
    },
    children: [
      {
        name: "Women",
        subtext: "For women 18-44",
        subtextDesktop: "For women 18-44",
        url: "/hair/women/product/core/women-advanced/",
        tag: `IMPROVED FORMULA`,
      },
      {
        name: "Women's Balance",
        subtext: "For women 45+ experiencing signs of hair thinning.",
        subtextDesktop: "For women 45+",
        url: "/hair/women/product/core/balance/",
      },
      {
        name: "Postpartum",
        subtext:
          "For women in the first year post-childbirth <br class='br-sm'/>experiencing signs of hair thinning and shedding.",
        subtextDesktop: "For women in the first year post-childbirth",
        url: "/hair/women/product/core/postpartum/",
      },
      {
        name: "Men",
        subtext: "For men 18+ experiencing signs of hair thinning and less scalp coverage.",
        subtextDesktop: "Switch to Nutrafol Men",
        url: "/hair/men/product/core/men/",
        isMens: true,
      },
    ],
    subCategories: [
      {
        name: "Stress",
        url: "/hair/women/product/booster/hair-growth-resilience-duo/",
      },
      {
        name: "Nutrition",
        url: "/hair/women/product/booster/hair-growth-synbiosis-duo/",
      },
      {
        name: "Aging",
        url: "/hair/women/product/booster/hair-growth-strength-duo/",
      },
      {
        name: "Hormones",
        url: "/hair/women/product/booster/hair-growth-equilibrium-duo/",
      },
      {
        name: "Lifestyle",
        url: "/hair/women/product/booster/hair-growth-shield-duo/",
      },
      {
        name: "Metabolism",
        url: "/hair/women/product/booster/hair-growth-longevity-duo/",
      },
      {
        name: "Scalp and Strand Care",
        url: "/hair/brand/product/category/#scalp",
        tag: "NEW",
      },
    ],
  },
  {
    name: "science",
    link: {
      text: "Science",
      url: "#",
    },
    children: [
      {
        type: "link",
        name: "Our Approach",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/2zbP23f082RlrmFDkg1FlE/488ccf42e4f4cd53e38a2b0ef09847fa/nav-approach.jpg",
        alt: "",
        text: "The science behind our whole-body approach to hair health.",
        url: "/hair/brand/learn/science/",
      },

      {
        type: "link",
        name: "Clinical Studies",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/5i7lgeYsDeGmzzW1bii4kT/ecbe9c622020d93512a94496754b26ce/nav_clinical_studies_img.jpg",
        alt: "",
        text: "A deep dive into how we put our hair growth formulas to the test.",
        url: "/hair/brand/learn/science/clinical-studies/",
      },
      {
        type: "link",
        name: "Ingredients",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/15gXMu9jA2ToKozg60xy8W/15515d879a161b1760df4eda0dcc84e7/nav-ingredients.jpg",
        alt: "",
        text: "How our naturally potent ingredients deliver results.",
        url: "/hair/brand/learn/science/ingredients/",
      },
      {
        type: "link",
        name: "Standards",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/4x7ElyBnGd9aKi06V3HNUt/b8f048d883ae5532cf0cf39a08ba28a5/nav-standards.jpg",
        alt: "",
        text: "Our commitment to quality, safety, and delivering results.",
        url: "/hair/brand/learn/science/our-standards/",
      },
    ],
  },
  {
    name: "results",
    link: {
      text: "Results",
      url: "/hair/brand/learn/results/customer-reviews/",
    },
  },
  {
    name: "account",
    isMobileOnly: true,
    link: {
      text: "Account",
      url: "#",
    },
    children,
  },
];

export const accordionNavigationData: AccordionNavigationItem[] = [
  {
    type: "hgn",
    open: true,
    name: "products",
    title: "Hair Growth Supplements",
    children: [
      {
        type: "link",
        title: "Women",
        subtitle: "For women 18-44",
        url: "/hair/women/product/core/women-advanced/",
        tag: `IMPROVED FORMULA`,
      },
      {
        type: "link",
        title: "Women's Balance",
        subtitle: "For women 45+",
        url: "/hair/women/product/core/balance/",
      },
      {
        type: "link",
        title: "Postpartum",
        subtitle: "For women in the first year post-childbirth",
        url: "/hair/women/product/core/postpartum/",
      },
      {
        type: "link",
        title: "Men",
        subtitle: "Switch to Nutrafol Men",
        url: "/hair/men/product/core/men/",
        isMens: true,
      },
      {
        type: "button",
        label: "Take the Quiz to Find Your Formula",
        url: "/hair/brand/quiz/",
      },
    ],
  },
  {
    type: "link",
    url: "/hair/brand/product/category/#scalp",
    name: "scalp-and-strand-care",
    title: "Scalp and Strand Care",
    tag: "NEW",
  },
  {
    type: "accordion",
    open: false,
    name: "causes",
    title: "Shop by Concern",
    children: [
      {
        type: "link",
        title: "Stress",
        url: "/hair/women/product/booster/hair-growth-resilience-duo/",
      },
      {
        type: "link",
        title: "Nutrition",
        url: "/hair/women/product/booster/hair-growth-synbiosis-duo/",
      },
      {
        type: "link",
        title: "Aging",
        url: "/hair/women/product/booster/hair-growth-strength-duo/",
      },
      {
        type: "link",
        title: "Hormones",
        url: "/hair/women/product/booster/hair-growth-equilibrium-duo/",
      },
      {
        type: "link",
        title: "Lifestyle",
        url: "/hair/women/product/booster/hair-growth-shield-duo/",
      },
      {
        type: "link",
        title: "Metabolism",
        url: "/hair/women/product/booster/hair-growth-longevity-duo/",
      },
      {
        type: "link",
        title: "Scalp and Strand Care",
        url: "/hair/brand/product/category/#scalp",
      },
    ],
  },
  {
    type: "accordion",
    open: false,
    name: "science",
    title: "Science",
    children: [
      {
        type: "link",
        title: "Our Approach",
        subtitle: "The science behind our whole-body approach to hair health.",
        url: "/hair/brand/learn/science/",
      },
      {
        type: "link",
        title: "Clinical Studies",
        subtitle: "A deep dive into how we put our hair growth formulas to the test.",
        url: "/hair/brand/learn/science/clinical-studies/",
      },
      {
        type: "link",
        title: "Ingredients",
        subtitle: "How our naturally potent ingredients deliver results.",
        url: "/hair/brand/learn/science/ingredients/",
      },
      {
        type: "link",
        title: "Standards",
        subtitle: "Our commitment to quality, safety, and delivering results.",
        url: "/hair/brand/learn/science/our-standards/",
      },
    ],
  },
  {
    type: "link",
    url: "/hair/brand/learn/results/customer-reviews/",
    name: "results",
    title: "Results",
  },
];

export const menHeaderData: HeaderDataItem[] = [
  {
    name: "shopmen",
    childrenTitle: "HAIR GROWTH SUPPLEMENTS",
    rootCauseCategoriesTitle: "Shop by Root Cause",
    isAlt: true,
    link: {
      text: "Shop",
      url: "#",
    },
    children: [
      {
        mode: "core",
        title: "Nutrafol Men",
        subtext: "For ages 18-49",
        url: "/hair/men/product/core/men/",
      },
      {
        mode: "core",
        title: "Nutrafol Men 50+",
        subtext: "For ages 50+",
        url: "/hair/men/product/core/men50/",
      },
      {
        mode: "root-cause",
        title: "Stress",
        url: "/hair/men/product/booster/hair-growth-resilience-duo/",
      },
      {
        mode: "root-cause",
        title: "Nutrition",
        url: "/hair/men/product/booster/hair-growth-synbiosis-duo/",
      },
      {
        mode: "root-cause",
        title: "Aging",
        url: "/hair/men/product/booster/hair-growth-strength-duo/",
      },
      {
        mode: "root-cause",
        title: "Lifestyle",
        url: "/hair/men/product/booster/hair-growth-shield-duo/",
      },
      {
        mode: "root-cause",
        title: "Metabolism",
        url: "/hair/men/product/booster/hair-growth-longevity-duo/",
      },
      {
        mode: "root-cause",
        title: "DHT Support",
        url: "/hair/men/product/booster/hair-growth-defense-duo/",
      },
      {
        mode: "root-cause",
        title: "Scalp Care",
        url: "/hair/men/product/category/#scalp",
      },
    ],
  },
  {
    name: "sciencemen",
    link: {
      text: "Science",
      url: "#",
    },
    children: [
      {
        type: "link",
        name: "Clinical Studies",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/6vTjWmn3zwXn2jj4UAnprt/8319a2e92f44faa83eb93a8fe9c6545f/men-nav-clinical-studies.jpg?fl=progressive",
        alt: "",
        text: "A deep dive into how we put our hair growth formulas to the test.",
        url: "/hair/brand/learn/science/clinical-studies/?site=men&product=Nutrafol+Men",
      },
      {
        type: "link",
        name: "Ingredients",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/7GTO7k3cfO8iB3UbxXwQfh/9451ff3267f1427dd3b9f9f08941a0d7/men-nav-ingredients.jpg?fl=progressive",
        alt: "",
        text: "How our naturally potent ingredients deliver results.",
        url: "/hair/brand/learn/science/ingredients/?site=men&product=Nutrafol+Men",
      },
      {
        type: "link",
        name: "Standards",
        image:
          "https://images.ctfassets.net/0rbfqd9c4jdo/6dnm5TDA8KIXNFnlfwbnD3/e62282debfdea41b24fe5fc19aac13b4/men-nav-standards.jpg?fl=progressive",
        alt: "",
        text: "Our commitment to quality, safety, and delivering results.",
        url: "/hair/brand/learn/science/our-standards/",
      },
    ],
  },
  {
    name: "results",
    link: {
      text: "Results",
      url: "/hair/men/learn/results/customer-reviews/",
    },
  },
  {
    name: "account",
    isMobileOnly: true,
    link: {
      text: "Account",
      url: "#",
    },
  },
];

export const accordionNavigationDataMen: AccordionNavigationItem[] = [
  {
    type: "hgn",
    name: "products",
    title: "Hair Growth Supplements",
    url: "#",
    children: menHeaderData
      .find((el) => el.name === "shopmen")
      ?.children.filter((el) => el.mode === "core"),
  },
  {
    type: "accordion",
    open: true,
    name: "root-cause",
    title: "Shop by Root Cause",
    children: menHeaderData
      .find((el) => el.name === "shopmen")
      ?.children.filter((el) => el.mode === "root-cause"),
  },
  {
    type: "accordion",
    open: false,
    name: "science",
    title: "Science",
    children: [
      {
        type: "link",
        title: "Clinical Studies",
        subtext: "A deep dive into how we put our hair growth formulas to the test.",
        url: "/hair/brand/learn/science/clinical-studies/?site=men&product=Nutrafol+Men",
      },
      {
        type: "link",
        title: "Ingredients",
        subtext: "How our high-quality ingredients are sourced and tested.",
        url: "/hair/brand/learn/science/ingredients/?site=men&product=Nutrafol+Men",
      },
      {
        type: "link",
        title: "Standards",
        subtext: "Our commitment to quality, safety, and products that actually work.",
        url: "/hair/brand/learn/science/our-standards/",
      },
    ],
  },
  {
    type: "link",
    name: "results",
    title: "Results",
    url: "/hair/men/learn/results/customer-reviews/",
  },
];

// Then expose a function that returns the data based on theme
export function getNavigationData(theme: ThemeTypes) {
  return {
    headerData: theme === "men" ? menHeaderData : headerData,
    accordionNavigationData: theme === "men" ? accordionNavigationDataMen : accordionNavigationData,
  };
}
